export default "\"2026/07/20_14:30\" \r\n";